import {$_PAGE_} from '../base/vars.js';
import PropertyQuickView from '../components/property-quick-view.js';
import Search from "../components/search/Search";

let searchInst;

function initializePropertyQuickView() {
  const bbmd = $('#bb-md');
  if(bbmd.length) {
    $('.search-body #list-view').on('click', 'a.hotel-image-link, a.hotel-url--name', (e) => {
      e.preventDefault();

      const hotelDetailsWrapperElement = $(e.currentTarget).closest('.hotel-details-wrapper');
      const propertyId = hotelDetailsWrapperElement.attr('id');
      const propertyUrl = e.currentTarget.getAttribute('href');
      const priceButtonAvailableElement = hotelDetailsWrapperElement.find('.hotel-rate.is-active .available .price-button');
      const pointsButtonAvailableElement = hotelDetailsWrapperElement.find('.hotel-rewards.is-active .available .price-button');
      const pointsButtonUnavailableElement = hotelDetailsWrapperElement.find('.hotel-rewards.is-active .unavailable .hotel-url');

      const notificationAttr = hotelDetailsWrapperElement.attr('data-notification');
      let bookNowUrl;
      let notificationData;

      if (!pointsButtonUnavailableElement.length && pointsButtonAvailableElement.length) {
        bookNowUrl = pointsButtonAvailableElement.attr('href');
      } else if (priceButtonAvailableElement.length) {
        bookNowUrl = priceButtonAvailableElement.attr('href');
      }

      if (notificationAttr) {
        notificationData = JSON.parse(decodeURIComponent(notificationAttr));
      }

      PropertyQuickView.init(propertyId, propertyUrl, bookNowUrl, notificationData);
    });
  }
}
if ($_PAGE_.is('.search-results-page')) {
  if (!$_PAGE_.is('.search-results-page-v2')) {
    searchInst = new Search();
    initializePropertyQuickView();
  }
}

//"searchresultlinkClick" Event Activation Point - Push Adobe Digital Data onclick of Search Results on Search Results Page.
window.addEventListener('load', () => {
  document.body.addEventListener('click', (e) => {
    const target = e.target;
    const listView = target.closest('#list-view');
    if (listView && listView.closest('.search-body') && target.classList.contains('hotel-url--name')) {
      const propertyAddress = target.parentElement.nextElementSibling.innerText;
      window.AdobeWebSdk && window.AdobeWebSdk.onSearchResultOptionClickOnSRP(target, propertyAddress);
    }
    if (listView && listView.closest('.search-body') && target.classList.contains('hotel-url--name')) {
      const propertyAddress = target.parentElement.nextElementSibling.innerText;
      window.AdobeWebSdk && window.AdobeWebSdk.onSearchResultOptionClickOnSRP(target, propertyAddress);
    }
  });
});

$(document).on('click', '.srp-review.review-section.srp-list-view, .rating-review-sec', (e) => {
  const triggeredEventName = 'ratingandreviewClick';
  const anchor = e.target.closest('a');
  //"ratingandreviewClick" Event Activation Point - Push Adobe Digital Data onclick customer rating on Search Results Page (SRP) or Property overview page..
  window.AdobeWebSdk && window.AdobeWebSdk.onClickMedalliaTracking(anchor, triggeredEventName);
});

$(document).on('click', '#review-rating-section .complete-review-section .load-more', (e) => {
  const triggeredEventName = 'loadmorereviewClick';
  //"loadmorereviewClick" Event Activation Point - Push Adobe Digital Data onclick of Load More button of review rating on PDP.
  window.AdobeWebSdk && window.AdobeWebSdk.onClickMedalliaTracking(e.target, triggeredEventName);
});

export default searchInst;
